// stores/user.js
import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
  state: () => ({
    userInfo: null
  }),
  actions: {
    updateUserInfo(newInfo) {
      // this.userInfo = { ...this.userInfo, ...newInfo }
      this.userInfo = newInfo
    }
  }
})